import { render, staticRenderFns } from "./AdditionalMenu.vue?vue&type=template&id=170524cd&"
import script from "./AdditionalMenu.vue?vue&type=script&lang=js&"
export * from "./AdditionalMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports